export class IPRupdatesPageModel {
  pageIndex: any;
  pageSize: any;
  whereCondition: string;
  orderBy: string;
  keywordFilter: string;
  fromupdatesDateFilter: string;
  toupdatesDateFilter: string;
  userID: string;
  unreadonly: string;
  updatetype: string;
  productId: string;
}

export class IPRupdatesPageModelV2 {
  pageNumber:number;
  pageSize: number;
  whereCondition: string;
  orderBy: string;
  keywordFilter: string;
  fromupdatesDateFilter: string;
  toupdatesDateFilter: string;
  userID: string;
  unreadonly: string;
  updatetype: string;
  productId: string;
  
}

export class IPCSupdatesPageModel {
  pageIndex: any;
  pageSize: any;
  whereCondition: string;
  orderBy: string;
  keywordFilter: string;
  fromupdatesDateFilter: string;
  toupdatesDateFilter: string;
  userID: string;
  unreadonly: string;
  updatetype: string;
}
